import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from "../environments/environment";
import { HttpClientModule } from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { AppInitService } from "@app/appinit.service";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { ServiceLocator } from "@app/core/services/service-locator/ServiceLocator";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AlertDialogueComponent } from "@app/core/services/alert/alert-dialogue-component";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgBusyModule } from "ng-busy";
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { NgIdleModule } from '@ng-idle/core';

export function loadEssentials(appInitService: AppInitService) {
  return () => appInitService.initEssentials();
}

@NgModule({
  declarations: [
    AppComponent,
    AlertDialogueComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    MatDialogModule,
    MatSnackBarModule,
    NgBusyModule,
    NgbModule,
    BrowserAnimationsModule,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAnalytics(() => getAnalytics()),
    NgIdleModule.forRoot()
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: loadEssentials,
      deps: [AppInitService],
      multi: true
    },
    {
      provide: 'env',
      useValue: environment
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    ServiceLocator.injector = injector;
  }
}
